module.exports = __webpack_public_path__ + "static/media/icon-invites.f9333b8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-invites.svg
// module id = 1370
// module chunks = 46